import { render, staticRenderFns } from "./AddEmployeeDialog.vue?vue&type=template&id=2510ff6b&scoped=true"
import script from "./AddEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./AddEmployeeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddEmployeeDialog.vue?vue&type=style&index=0&id=2510ff6b&prod&lang=css"
import style1 from "./AddEmployeeDialog.vue?vue&type=style&index=1&id=2510ff6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510ff6b",
  null
  
)

export default component.exports